export default {
	namespaced: true,
	state: {
		locale: 'ko',
	},
	mutations: {
		toggleLocale(state) {
			state.locale = state.locale === 'ko' ? 'en' : 'ko';
		},
	},
	getters: {
		LOCALE(state) {
			return state.locale;
		},
	},
};
